import { render, staticRenderFns } from "./vFormBUTTONMixin.js.vue?vue&type=template&id=838a4a62&"
import script from "./vFormBUTTONMixin.js.vue?vue&type=script&lang=js&"
export * from "./vFormBUTTONMixin.js.vue?vue&type=script&lang=js&"
import style0 from "./vFormBUTTONMixin.js.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports